// Polish dictionary — the source of truth for translation keys.
// To add a language, create e.g. en.ts with the same keys and register it
// in dictionaries (src/i18n/index.tsx).
export const pl = {
  "notifications.title": "Powiadomienia",
  "notifications.new": "Nowe powiadomienie",
  "notifications.empty": "Brak spraw wymagających uwagi",
  "common.logout": "Wyloguj",
  "common.logoutSuccess": "Wylogowano",
  "common.logoutError": "Błąd podczas wylogowania",
  "nav.menu": "Menu",
  "nav.tasks": "Zadania",
  "nav.account": "Konto",
  "record.expand": "Rozwiń",
  "record.collapse": "Zwiń",
  "filters.toggle": "Filtry",
} as const;
